<template>
  <div class="oven">
    <div class="content c895">
      <h2>Dodajte pečico</h2>
    </div>
    <div class="content c590">
      <div class="popup popDev2" :style="{display: !err ? 'none' : 'block'}">
        <div class="inner">
          <h3></h3>
          <div class="msg">
            <h3>Izpolniti je potrebno vsaj eno polje za pogostost uporabe naprave!</h3>
          </div>

          <div class="btns">
            <a href="javascript:void(0)" class="btn" title="OK" @click="err = false">V REDU</a>
          </div>
        </div>
      </div>
      <div class="form">
        <h3>VPIŠITE PODATKE O PEČICI</h3>
        <div class="f-item select">
          <label>
            Starost pečice:
            <span
              id
              style="color:Red;float:none;font-size:1em;"
              :style="{visibility: !err2 ? 'hidden' : 'visible'}"
            >*</span>
            <span>(oz. leto izdelave naprave)</span>
          </label>
          <select v-model="starost">
            <option value="0">Izberite</option>
            <option value="1">do 1998</option>
            <option value="2">od 1998 do 2007</option>
            <option value="3">od 2007</option>
            <option value="4">A - konvencionalna</option>
            <option value="5">A - večsistemska</option>
            <option value="6">A+ - konvencionalna</option>
            <option value="7">A+ - večsistemska</option>
          </select>
        </div>
      </div>
      <div class="question">
        <p>
          Kolikokrat
          <b>na teden</b> uporabljate pečico in na kateri temperaturi?
        </p>
        <div class="help">
          <a href="#" class="help" title="Help">Help</a>
          <div class="tooltip">
            Na porabo elektrike in višino računa vpliva tarifa, v kateri pečete, in temperatura, na kateri pečete. Manjša tarifa velja med tednom ponoči (od 22.00 do 6.00) ter ob sobotah, nedeljah ter dela prostih dnevih cel dan.
            <p></p>
          </div>
        </div>
      </div>
      <div class="answer-list">
        <ul id>
          <li class="first">
            <div>PON-PET, 6:00-22:00</div>
            <div>PON-PET, 22:00-6:00 IN SOB-NED</div>
          </li>
          <li class="answer odd">
            <span>do 200°C</span>
            <div>
              <input type="text" v-model="teden" />
              <span>x</span>
            </div>
            <div class="last">
              <input type="text" v-model="vikend" />
              <span>x</span>
            </div>
          </li>
          <li class="answer">
            <span>nad 200°C</span>
            <div>
              <input type="text" v-model="teden2" />
              <span>x</span>
            </div>
            <div class="last">
              <input type="text" v-model="vikend2" />
              <span>x</span>
            </div>
          </li>
        </ul>
      </div>
      <div class="add">
        <input type="submit" name value="Dodaj" @click="addedApplianceNum()" />
      </div>
    </div>
    <div class="content r-c">
      <div class="c282 info">
        <h3>INFO O PEČICI</h3>
        <p>Porabo električne energije pri uporabi pečice težko izmerimo, saj po navadi na električno omrežje ni priključena prek navadne vtičnice. Porab ocenimo glede na naslednje parametre:: na kakšno temperaturo segrevamo pečico, kakšno količino hrane pripravljamo, koliko časa pečico uporabljamo in kateri program uporabimo. Proizvajalci so v zadnjih letih uspeli precej izboljšati energetsko učinkovitost električnih pečic.</p>

        <div class="average">
          <h4>Povprečna poraba tipičnega pečice na leto</h4>
          <span>307 kWh/leto</span>
          <p>
            <strong>23,17 € / leto</strong> (enotarifno)
            <br />
            <strong>19,87 € / leto</strong> (dvotarifno)
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PecicaObj from '../classes/pecica';

export default {
  data: function () {
    return {
      starost: '0',
      teden: 0,
      vikend: 0,
      teden2: 0,
      vikend2: 0,
      err: false,
      err2: false,
    };
  },
  methods: {
    addedApplianceNum() {
      console.log('From oven');
      const P = new PecicaObj(
        this.starost,
        this.teden,
        this.vikend,
        this.teden2,
        this.vikend2
      );
      this.$emit('applianceFormClicked', P);
    },
  },
};
</script>

<style>
</style>